import * as Sentry from '@sentry/react';

// Default Sentry init covers error capture + tracing only — no session replay.
// Replay is gated behind authentication via enableSessionReplay() in useAuth so
// Tier B visitors (creator's clients on showcase/booking pages) are never
// recorded. Error capture itself sets no cookies / no storage — it's safe to
// run globally. See tasks/explorations/cookies-audit-2026-05-13.html.

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    sampleRate: 1.0,
    tracesSampleRate: 0.2,
    // Replay sample rates are still configured here so they take effect once
    // replayIntegration is added at runtime via enableSessionReplay.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

let replayEnabled = false;
export function enableSessionReplay(): void {
  if (replayEnabled || !dsn) return;
  Sentry.addIntegration(Sentry.replayIntegration());
  replayEnabled = true;
}

export { Sentry };
